import type { MemorySliceDescriptor } from "../../shared";

/**
 * Authoring helper that preserves generic `TValue` on an ephemeral slice descriptor.
 *
 * @typeParam TValue In-memory slice type.
 * @param descriptor Slice configuration (`key` + `default`).
 * @returns The same descriptor reference, typed for export and registry inclusion.
 */
export const defineEphemeralSlice = <TValue>(
    descriptor: MemorySliceDescriptor<TValue>,
): MemorySliceDescriptor<TValue> => {
    return descriptor;
};
